// Module
var code = `<template class="mdc-data-table__header-cell--with-sort \${sort ? 'mdc-data-table__header-cell--sorted' : ''}" data-column-id.bind="columnId" aria-sort="\${sort}">
  <div class="mdc-data-table__header-cell-wrapper">
    <div class="mdc-data-table__header-cell-label">
      <slot></slot>
    </div>
    <button mdc-icon-button class="mdc-data-table__sort-icon-button" aria-label.bind="buttonAriaLabel" aria-describedby.bind="statusLabelId" icon="arrow_upward"></button>
    <div class="mdc-data-table__sort-status-label" aria-hidden="true" id.bind="statusLabelId"></div>
  </div>
</template>
`;
// Exports
export default code;